import { takeLatest, call, put, select } from 'redux-saga/effects';

import { TASK_STATUSES } from 'modules/tasks/data/constants';

import taskService, { transformFiltersParamsToApi } from 'services/taskService';

import { getUserId } from 'store/session/selectors';

import { dashboardListInit, types } from './actions';

export default function* root() {
  yield takeLatest(types.DASHBOARD_LIST_INIT_REQUEST, watchInitDashboard);
}

function* watchInitDashboard() {
  // fetch all open and overdue tasks assigned to the current user
  try {
    const activeUserId = yield select(getUserId);
    const queryParams = transformFiltersParamsToApi({
      assignedToIn: [activeUserId],
      statusIn: [TASK_STATUSES.OPEN, TASK_STATUSES.OVERDUE],
    });

    const { results } = yield call(taskService.list, queryParams);
    yield put(dashboardListInit.success({ tasks: results }));
  } catch (error) {
    yield put(dashboardListInit.error(error));
  }
}
